module.exports = __webpack_public_path__ + "static/media/giant_paper_straw5.5ccf11ab.png";